// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1tihG","info":"Note_info__3f6kn","note":"Note_note__3tDKO","actions":"Note_actions__2ZrLo"};